import i18n from "i18next";
import Backend from "i18next-http-backend";
// import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

i18n
  .use(Backend)
  // .use(LanguageDetector)
  // browser based language detection makes calls to try to get browser's lang file,
  // and since we only have en atm this is not currently needed;
  .use(initReactI18next)
  .init({
    fallbackLng: "en",
    ns: ["common", "planner", "ai", "studio", "auth", "workspace"],
    defaultNS: "common",
    debug: false,
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
